import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Advertisers() {
  const Users = [
    {
      id: '01',
      image: '/tosca-2022/ads/jerry-seiner.jpg',
      link: 'https://www.jerryseinercadillac.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Jerry Seiner Cadillac',
      class: 'webFormat',
    },
    {
      id: '02',
      image: '/tosca-2022/ads/cultural-enterprise.jpg',
      link: 'https://www.williamcall.net/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'William Call',
      class: 'webFormat',
    },
    {
      id: '03',
      image: '/tosca-2022/ads/Challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      id: '04',
      image: '/tosca-2022/ads/lavahotsprings.jpg',
      link: 'https://www.lavahotsprings.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Lava Hot Springs',
      class: 'webFormat',
    },
    {
      id: '05',
      image: '/tosca-2022/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Tuacahn',
      class: 'webFormat',
    },
    {
      id: '06',
      image: '/tosca-2022/ads/Hamilton.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      id: '07',
      image: '/tosca-2022/ads/RCWilley.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      id: '08',
      image: '/tosca-2022/ads/ufo.jpg',
      link: 'https://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      id: '09',
      image: '/tosca-2022/ads/UniversityCU.jpg',
      link: 'https://www.ucreditu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'University of Utah Credit Union',
      class: 'webFormat',
    },
    {
      id: '10',
      image: '/tosca-2022/ads/shakespeare.jpg',
      link: 'https://www.bard.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Utah Shakespeare Festival',
      class: 'webFormat',
    },
    {
      id: '11',
      image: '/tosca-2022/ads/adibs.jpg',
      link: 'https://www.adibs.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Adibs Rug Gallery',
      class: 'webFormat',
    },
    {
      id: '12',
      image: '/tosca-2022/ads/slc-airport.jpg',
      link: 'https://www.slcairport.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahopera',
      alt: 'Salt Lake City Airport',
      class: 'webFormat',
    },
  ];

  Users.sort((a, b) => a.alt.localeCompare(b.alt));

  return (
    <div>
      {Users.map((data) => (
        <details key={data.id}>
          <summary>{data.alt}</summary>
          <OutboundLink
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.image} alt={data.alt} className={data.class} />
          </OutboundLink>
        </details>
      ))}
    </div>
  );
}

export default Advertisers;
